export const initialState = {
    search_text: ""
}